import { NgLetDirective } from '@shared/directives/ng-let/ng-let.directive';

export class LetContext<T> {
  constructor(private readonly dir: NgLetDirective<T>) {}

  public get ngLet(): T {
    return this.dir.ngLet;
  }
}
